export const campaignData = [
    {
        "campaignType": "STANDARD",
        "id": 24945,
        "name": "5552 - 01/11/2023 - 01/02/2024 Tesco - 01/11/2023 00:00:00 01/02/2024 00:00:00 (2)",
        "advertiserId": 2621,
        "orderId": 5552,
        "startDate": "2023-12-01T00:00:00+00:00",
        "endDate": "2024-01-31T00:00:00+00:00",
        "campaignRevenue": {
            "id": null,
            "type": "CPM",
            "value": 3,
            "currency": "EUR"
        },
        "status": "DRAFT",
        "validationStatus": null,
        "statusName": "DRAFT",
        "billing": "UNSOLD",
        "campaignObjective": {
            "id": null,
            "orderCampaignId": null,
            "type": "IMPRESSIONS",
            "value": 3,
            "unlimited": false,
            "managedObjective": false,
            "optimisedObjective": false
        },
        "campaignObjectiveId": null,
        "categoryIds": [
            943,
            944,
            945,
            946,
            947,
            948,
            949,
            950,
            951,
            952,
            953,
            954
        ],
        "campaignDeliveryPacing": {
            "id": "00000000-0000-0000-0000-000000000000",
            "orderCampaignId": null,
            "type": "EVENLY",
            "priority": 1
        },
        "pacing": "EVENLY - 1",
        "deliveryCappingRules": null,
        "comments": null,
        "externalReference": null,
        "objectiveType": "IMPRESSIONS",
        "extensions": null,
        "inheritCategories": true,
        "adClashing": false,
        "briefAutomaticallyApproved": false,
        "createdById": null,
        "createdDate": null,
        "modifiedById": null,
        "modifiedDate": null,
        "lastViewed": null,
        "proximity": null,
        "postcodes": null,
        "regions": null,
        "cities": null,
        "archived": false,
        "templateIds": null,
        "digitalAdTypeId": null,
        "adswizzOrderDigitalProducts": null,
        "adswizzOrderDigitalDeviceTypes": null,
        "publisherGoal": false,
        "adDuration": null,
        "adPosition": null,
        "avails": null,
        "actuals": null,
        "allowEdit": true,
        "allowDelete": true
    },
    {
        "campaignType": "STANDARD",
        "id": 24933,
        "name": "5552 - 01/11/2023 - 01/02/2024 Tesco - 01/11/2023 00:00:00 01/02/2024 00:00:00",
        "advertiserId": 2621,
        "orderId": 5552,
        "startDate": "2023-12-01T00:00:00+00:00",
        "endDate": "2024-01-31T00:00:00+00:00",
        "campaignRevenue": {
            "id": null,
            "type": "CPM",
            "value": 3,
            "currency": "EUR"
        },
        "status": "DRAFT",
        "validationStatus": "INVALID_CITIES",
        "statusName": "INVALID_CITIES",
        "billing": "UNSOLD",
        "campaignObjective": {
            "id": null,
            "orderCampaignId": null,
            "type": "IMPRESSIONS",
            "value": 3,
            "unlimited": false,
            "managedObjective": false,
            "optimisedObjective": false
        },
        "campaignObjectiveId": null,
        "categoryIds": [
            943,
            944,
            945,
            946,
            947,
            948,
            949,
            950,
            951,
            952,
            953,
            954
        ],
        "campaignDeliveryPacing": {
            "id": "00000000-0000-0000-0000-000000000000",
            "orderCampaignId": null,
            "type": "EVENLY",
            "priority": 1
        },
        "pacing": "EVENLY - 1",
        "deliveryCappingRules": null,
        "comments": null,
        "externalReference": null,
        "objectiveType": "IMPRESSIONS",
        "extensions": null,
        "inheritCategories": true,
        "adClashing": false,
        "briefAutomaticallyApproved": false,
        "createdById": null,
        "createdDate": null,
        "modifiedById": null,
        "modifiedDate": null,
        "lastViewed": null,
        "proximity": null,
        "postcodes": null,
        "regions": null,
        "cities": null,
        "archived": false,
        "templateIds": null,
        "digitalAdTypeId": null,
        "adswizzOrderDigitalProducts": null,
        "adswizzOrderDigitalDeviceTypes": null,
        "publisherGoal": false,
        "adDuration": 30000,
        "adPosition": "UNDEFINED",
        "avails": null,
        "actuals": null,
        "allowEdit": true,
        "allowDelete": true
    }
];


export const performance_dummy_data = {
    "key": null,
    "total": {
        "totalSpend": 143561.94585001416,
        "attributionConversionReachUniqueUsers": 4411,
        "demandECPM": 8.061969697126235,
        "specialFormatFeeSum": 0.05100391,
        "attributionClickConversionRate": 0,
        "impressions": 208587316,
        "objectiveCountableSum": 208071730,
        "dataECPM": 0.04279849021297172,
        "attributionViewConversionRate": 0,
        "demandAttributionFee": 1385.6503499998994
    },
    "data": [
        {
            "key": "__time",
            "total": {
                "__time": {
                    "start": "2023-12-11T00:00:00+0000",
                    "end": "2023-12-12T00:00:00+0000"
                },
                "totalSpend": 4288.97684999996,
                "attributionConversionReachUniqueUsers": 10,
                "demandECPM": 7.4292906012536655,
                "specialFormatFeeSum": 0.00159314,
                "attributionClickConversionRate": 0,
                "impressions": 6298982,
                "objectiveCountableSum": 6287860,
                "dataECPM": 0.0303648936204038,
                "attributionViewConversionRate": 0,
                "demandAttributionFee": 43.23735000000021
            },
            "data": [
                {
                    "key": "publisherName",
                    "total": {
                        "demandECPM": 5.496098964455038,
                        "impressions": 2867090,
                        "objectiveCountableSum": 2867090,
                        "demandAttributionFee": 4.823549999999998,
                        "publisherId": 9,
                        "totalSpend": 343.0963500000009,
                        "attributionConversionReachUniqueUsers": 0,
                        "specialFormatFeeSum": 0,
                        "publisherName": "(9) talkSPORT | Wireless | Instream",
                        "attributionClickConversionRate": 0,
                        "dataECPM": 0.0018480061665312245,
                        "attributionViewConversionRate": 0
                    },
                    "data": []
                },
                {
                    "key": "publisherName",
                    "total": {
                        "demandECPM": 9.539292197488638,
                        "impressions": 306286,
                        "objectiveCountableSum": 306286,
                        "demandAttributionFee": 3.0481500000000072,
                        "publisherId": 198,
                        "totalSpend": 320.16434999999984,
                        "attributionConversionReachUniqueUsers": 4,
                        "specialFormatFeeSum": 0,
                        "publisherName": "(198) Magic (National) | Bauer | Instream",
                        "attributionClickConversionRate": 0,
                        "dataECPM": 0.04980018675355718,
                        "attributionViewConversionRate": 0
                    },
                    "data": []
                },
                {
                    "key": "publisherName",
                    "total": {
                        "demandECPM": 9.647914211893628,
                        "impressions": 281764,
                        "objectiveCountableSum": 281764,
                        "demandAttributionFee": 5.282999999999999,
                        "publisherId": 62,
                        "totalSpend": 550.1368999999988,
                        "attributionConversionReachUniqueUsers": 2,
                        "specialFormatFeeSum": 0,
                        "publisherName": "(62) Absolute Radio | Bauer | Instream",
                        "attributionClickConversionRate": 0,
                        "dataECPM": 0.06901271986485148,
                        "attributionViewConversionRate": 0
                    },
                    "data": []
                },
                {
                    "key": "publisherName",
                    "total": {
                        "demandECPM": 9.965881117461509,
                        "impressions": 256152,
                        "objectiveCountableSum": 256152,
                        "demandAttributionFee": 3.5308500000000094,
                        "publisherId": 143,
                        "totalSpend": 359.1871499999998,
                        "attributionConversionReachUniqueUsers": 0,
                        "specialFormatFeeSum": 0,
                        "publisherName": "(143) Planet Rock | Bauer | Instream",
                        "attributionClickConversionRate": 0,
                        "dataECPM": 0.05627869390049664,
                        "attributionViewConversionRate": 0
                    },
                    "data": []
                },
                {
                    "key": "publisherName",
                    "total": {
                        "demandECPM": 5.34533257198423,
                        "impressions": 176879,
                        "objectiveCountableSum": 176879,
                        "demandAttributionFee": 0.22514999999999996,
                        "publisherId": 20,
                        "totalSpend": 16.201749999999997,
                        "attributionConversionReachUniqueUsers": 0,
                        "specialFormatFeeSum": 0.00159314,
                        "publisherName": "(20) Virgin Radio UK | Wireless | Instream",
                        "attributionClickConversionRate": 0,
                        "dataECPM": 0.0027646017899241853,
                        "attributionViewConversionRate": 0
                    },
                    "data": []
                },
                {
                    "key": "publisherName",
                    "total": {
                        "demandECPM": 8.75584873760846,
                        "impressions": 160291,
                        "objectiveCountableSum": 160291,
                        "demandAttributionFee": 0.4622999999999998,
                        "publisherId": 347,
                        "totalSpend": 32.72999999999999,
                        "attributionConversionReachUniqueUsers": 0,
                        "specialFormatFeeSum": 0,
                        "publisherName": "(347) talkRADIO | Wireless | Instream",
                        "attributionClickConversionRate": 0,
                        "dataECPM": 0.004115015814986494,
                        "attributionViewConversionRate": 0
                    },
                    "data": []
                },
                {
                    "key": "publisherName",
                    "total": {
                        "demandECPM": 9.588966298462754,
                        "impressions": 156254,
                        "objectiveCountableSum": 156254,
                        "demandAttributionFee": 2.339850000000005,
                        "publisherId": 33,
                        "totalSpend": 241.02294999999992,
                        "attributionConversionReachUniqueUsers": 2,
                        "specialFormatFeeSum": 0,
                        "publisherName": "(33) Greatest Hits Radio (National) | Bauer | Instream",
                        "attributionClickConversionRate": 0,
                        "dataECPM": 0.06797489984256411,
                        "attributionViewConversionRate": 0
                    },
                    "data": []
                },
                {
                    "key": "publisherName",
                    "total": {
                        "demandECPM": 8.986530805457082,
                        "impressions": 123582,
                        "objectiveCountableSum": 123582,
                        "demandAttributionFee": 1.4731500000000017,
                        "publisherId": 123,
                        "totalSpend": 150.63955000000007,
                        "attributionConversionReachUniqueUsers": 0,
                        "specialFormatFeeSum": 0,
                        "publisherName": "(123) Kisstory | Bauer | Instream",
                        "attributionClickConversionRate": 0,
                        "dataECPM": 0.04017696751954171,
                        "attributionViewConversionRate": 0
                    },
                    "data": []
                }
            ],
            "attributes": {
                "granularity": "DAY",
                "valueType": "TIME"
            }
        },
        {
            "key": "__time",
            "total": {
                "__time": {
                    "start": "2023-12-10T00:00:00+0000",
                    "end": "2023-12-11T00:00:00+0000"
                },
                "totalSpend": 4354.340900000152,
                "attributionConversionReachUniqueUsers": 51,
                "demandECPM": 8.429451217838327,
                "specialFormatFeeSum": 0,
                "attributionClickConversionRate": 0,
                "impressions": 6656116,
                "objectiveCountableSum": 6638554,
                "dataECPM": 0.030958963352559966,
                "attributionViewConversionRate": 0,
                "demandAttributionFee": 44.23290000000526
            },
            "data": [
                {
                    "key": "publisherName",
                    "total": {
                        "demandECPM": 7.656145536674091,
                        "impressions": 2297469,
                        "objectiveCountableSum": 2297469,
                        "demandAttributionFee": 4.045050000000031,
                        "publisherId": 9,
                        "totalSpend": 285.66194999999976,
                        "attributionConversionReachUniqueUsers": 1,
                        "specialFormatFeeSum": 0,
                        "publisherName": "(9) talkSPORT | Wireless | Instream",
                        "attributionClickConversionRate": 0,
                        "dataECPM": 0.0027235187939422716,
                        "attributionViewConversionRate": 0
                    },
                    "data": []
                },
                {
                    "key": "publisherName",
                    "total": {
                        "demandECPM": 9.957890382281928,
                        "impressions": 389791,
                        "objectiveCountableSum": 389791,
                        "demandAttributionFee": 4.726349999999978,
                        "publisherId": 143,
                        "totalSpend": 474.4519500000013,
                        "attributionConversionReachUniqueUsers": 5,
                        "specialFormatFeeSum": 0,
                        "publisherName": "(143) Planet Rock | Bauer | Instream",
                        "attributionClickConversionRate": 0,
                        "dataECPM": 0.04630442980982022,
                        "attributionViewConversionRate": 0
                    },
                    "data": []
                },
                {
                    "key": "publisherName",
                    "total": {
                        "demandECPM": 7.193918915204223,
                        "impressions": 363792,
                        "objectiveCountableSum": 363792,
                        "demandAttributionFee": 3.472200000000007,
                        "publisherId": 198,
                        "totalSpend": 361.5425999999992,
                        "attributionConversionReachUniqueUsers": 10,
                        "specialFormatFeeSum": 0,
                        "publisherName": "(198) Magic (National) | Bauer | Instream",
                        "attributionClickConversionRate": 0,
                        "dataECPM": 0.04310278950609054,
                        "attributionViewConversionRate": 0
                    },
                    "data": []
                },
                {
                    "key": "publisherName",
                    "total": {
                        "demandECPM": 9.250803281297086,
                        "impressions": 238808,
                        "objectiveCountableSum": 238808,
                        "demandAttributionFee": 2.8088999999999977,
                        "publisherId": 65,
                        "totalSpend": 279.22619999999955,
                        "attributionConversionReachUniqueUsers": 2,
                        "specialFormatFeeSum": 0,
                        "publisherName": "(65) Absolute 80s | Bauer | Instream",
                        "attributionClickConversionRate": 0,
                        "dataECPM": 0.05411125255435264,
                        "attributionViewConversionRate": 0
                    },
                    "data": []
                },
                {
                    "key": "publisherName",
                    "total": {
                        "demandECPM": 8.816274928118103,
                        "impressions": 238586,
                        "objectiveCountableSum": 238586,
                        "demandAttributionFee": 3.9812999999999845,
                        "publisherId": 62,
                        "totalSpend": 414.67260000000005,
                        "attributionConversionReachUniqueUsers": 5,
                        "specialFormatFeeSum": 0,
                        "publisherName": "(62) Absolute Radio | Bauer | Instream",
                        "attributionClickConversionRate": 0,
                        "dataECPM": 0.06192484051872153,
                        "attributionViewConversionRate": 0
                    },
                    "data": []
                },
                {
                    "key": "publisherName",
                    "total": {
                        "demandECPM": 4.261375779577323,
                        "impressions": 214860,
                        "objectiveCountableSum": 214860,
                        "demandAttributionFee": 0.19470000000000007,
                        "publisherId": 20,
                        "totalSpend": 14.061599999999997,
                        "attributionConversionReachUniqueUsers": 0,
                        "specialFormatFeeSum": 0,
                        "publisherName": "(20) Virgin Radio UK | Wireless | Instream",
                        "attributionClickConversionRate": 0,
                        "dataECPM": 0.0022610071674578837,
                        "attributionViewConversionRate": 0
                    },
                    "data": []
                },
                {
                    "key": "publisherName",
                    "total": {
                        "demandECPM": 9.48003297684976,
                        "impressions": 195895,
                        "objectiveCountableSum": 195895,
                        "demandAttributionFee": 1.0687499999999968,
                        "publisherId": 200,
                        "totalSpend": 108.53554999999994,
                        "attributionConversionReachUniqueUsers": 1,
                        "specialFormatFeeSum": 0,
                        "publisherName": "(200) Mellow Magic | Bauer | Instream",
                        "attributionClickConversionRate": 0,
                        "dataECPM": 0.05983894433242176,
                        "attributionViewConversionRate": 0
                    },
                    "data": []
                },
                {
                    "key": "publisherName",
                    "total": {
                        "demandECPM": 9.554517862351215,
                        "impressions": 195411,
                        "objectiveCountableSum": 195411,
                        "demandAttributionFee": 0.32340000000000046,
                        "publisherId": 347,
                        "totalSpend": 23.045599999999997,
                        "attributionConversionReachUniqueUsers": 0,
                        "specialFormatFeeSum": 0,
                        "publisherName": "(347) talkRADIO | Wireless | Instream",
                        "attributionClickConversionRate": 0,
                        "dataECPM": 0.0043257544355231135,
                        "attributionViewConversionRate": 0
                    },
                    "data": []
                }
            ],
            "attributes": {
                "granularity": "DAY",
                "valueType": "TIME"
            }
        },
        {
            "key": "__time",
            "total": {
                "__time": {
                    "start": "2023-12-09T00:00:00+0000",
                    "end": "2023-12-10T00:00:00+0000"
                },
                "totalSpend": 4584.060450000249,
                "attributionConversionReachUniqueUsers": 76,
                "demandECPM": 8.251632841722477,
                "specialFormatFeeSum": 0,
                "attributionClickConversionRate": 0,
                "impressions": 7181407,
                "objectiveCountableSum": 7161135,
                "dataECPM": 0.030719089920801308,
                "attributionViewConversionRate": 0,
                "demandAttributionFee": 45.826650000009124
            },
            "data": [
                {
                    "key": "publisherName",
                    "total": {
                        "demandECPM": 6.578033202492394,
                        "impressions": 2062556,
                        "objectiveCountableSum": 2062556,
                        "demandAttributionFee": 2.4207000000000294,
                        "publisherId": 9,
                        "totalSpend": 171.22219999999942,
                        "attributionConversionReachUniqueUsers": 0,
                        "specialFormatFeeSum": 0,
                        "publisherName": "(9) talkSPORT | Wireless | Instream",
                        "attributionClickConversionRate": 0,
                        "dataECPM": 0.0025977961325654567,
                        "attributionViewConversionRate": 0
                    },
                    "data": []
                },
                {
                    "key": "publisherName",
                    "total": {
                        "demandECPM": 10.04953445536347,
                        "impressions": 422924,
                        "objectiveCountableSum": 422924,
                        "demandAttributionFee": 4.42664999999996,
                        "publisherId": 143,
                        "totalSpend": 446.30955000000205,
                        "attributionConversionReachUniqueUsers": 9,
                        "specialFormatFeeSum": 0,
                        "publisherName": "(143) Planet Rock | Bauer | Instream",
                        "attributionClickConversionRate": 0,
                        "dataECPM": 0.04094896482583002,
                        "attributionViewConversionRate": 0
                    },
                    "data": []
                },
                {
                    "key": "publisherName",
                    "total": {
                        "demandECPM": 7.5538746722448735,
                        "impressions": 418758,
                        "objectiveCountableSum": 418758,
                        "demandAttributionFee": 3.557700000000021,
                        "publisherId": 198,
                        "totalSpend": 371.50899999999865,
                        "attributionConversionReachUniqueUsers": 17,
                        "specialFormatFeeSum": 0,
                        "publisherName": "(198) Magic (National) | Bauer | Instream",
                        "attributionClickConversionRate": 0,
                        "dataECPM": 0.04007995071138825,
                        "attributionViewConversionRate": 0
                    },
                    "data": []
                },
                {
                    "key": "publisherName",
                    "total": {
                        "demandECPM": 9.03603820785383,
                        "impressions": 301404,
                        "objectiveCountableSum": 301404,
                        "demandAttributionFee": 4.322549999999986,
                        "publisherId": 62,
                        "totalSpend": 448.50214999999974,
                        "attributionConversionReachUniqueUsers": 6,
                        "specialFormatFeeSum": 0,
                        "publisherName": "(62) Absolute Radio | Bauer | Instream",
                        "attributionClickConversionRate": 0,
                        "dataECPM": 0.055242797043169506,
                        "attributionViewConversionRate": 0
                    },
                    "data": []
                },
                {
                    "key": "publisherName",
                    "total": {
                        "demandECPM": 4.914070999060809,
                        "impressions": 250285,
                        "objectiveCountableSum": 250285,
                        "demandAttributionFee": 0.16770000000000032,
                        "publisherId": 20,
                        "totalSpend": 12.060899999999991,
                        "attributionConversionReachUniqueUsers": 0,
                        "specialFormatFeeSum": 0,
                        "publisherName": "(20) Virgin Radio UK | Wireless | Instream",
                        "attributionClickConversionRate": 0,
                        "dataECPM": 0.0031164472501348625,
                        "attributionViewConversionRate": 0
                    },
                    "data": []
                },
                {
                    "key": "publisherName",
                    "total": {
                        "demandECPM": 8.28331896954679,
                        "impressions": 235314,
                        "objectiveCountableSum": 235314,
                        "demandAttributionFee": 2.8221000000000087,
                        "publisherId": 88,
                        "totalSpend": 292.9675999999972,
                        "attributionConversionReachUniqueUsers": 6,
                        "specialFormatFeeSum": 0,
                        "publisherName": "(88) Hits Radio (Clyde 1) | Bauer | Instream",
                        "attributionClickConversionRate": 0,
                        "dataECPM": 0.04706031090372788,
                        "attributionViewConversionRate": 0
                    },
                    "data": []
                },
                {
                    "key": "publisherName",
                    "total": {
                        "demandECPM": 8.054412274573586,
                        "impressions": 231894,
                        "objectiveCountableSum": 231894,
                        "demandAttributionFee": 2.1928500000000057,
                        "publisherId": 123,
                        "totalSpend": 222.7277499999989,
                        "attributionConversionReachUniqueUsers": 5,
                        "specialFormatFeeSum": 0,
                        "publisherName": "(123) Kisstory | Bauer | Instream",
                        "attributionClickConversionRate": 0,
                        "dataECPM": 0.03120951814190951,
                        "attributionViewConversionRate": 0
                    },
                    "data": []
                },
                {
                    "key": "publisherName",
                    "total": {
                        "demandECPM": 9.406306253601345,
                        "impressions": 227341,
                        "objectiveCountableSum": 227341,
                        "demandAttributionFee": 2.5185000000000026,
                        "publisherId": 65,
                        "totalSpend": 249.64549999999858,
                        "attributionConversionReachUniqueUsers": 4,
                        "specialFormatFeeSum": 0,
                        "publisherName": "(65) Absolute 80s | Bauer | Instream",
                        "attributionClickConversionRate": 0,
                        "dataECPM": 0.049687253948912616,
                        "attributionViewConversionRate": 0
                    },
                    "data": []
                }
            ],
            "attributes": {
                "granularity": "DAY",
                "valueType": "TIME"
            }
        },
        {
            "key": "__time",
            "total": {
                "__time": {
                    "start": "2023-12-08T00:00:00+0000",
                    "end": "2023-12-09T00:00:00+0000"
                },
                "totalSpend": 7031.429250001217,
                "attributionConversionReachUniqueUsers": 251,
                "demandECPM": 7.2216997084963195,
                "specialFormatFeeSum": 0.00317646,
                "attributionClickConversionRate": 0,
                "impressions": 9720354,
                "objectiveCountableSum": 9699522,
                "dataECPM": 0.027682034228073985,
                "attributionViewConversionRate": 0,
                "demandAttributionFee": 71.07284999998149
            },
            "data": [
                {
                    "key": "publisherName",
                    "total": {
                        "demandECPM": 5.348767585359571,
                        "impressions": 3974969,
                        "objectiveCountableSum": 3974969,
                        "demandAttributionFee": 6.690749999999905,
                        "publisherId": 9,
                        "totalSpend": 478.85555000000033,
                        "attributionConversionReachUniqueUsers": 0,
                        "specialFormatFeeSum": 0,
                        "publisherName": "(9) talkSPORT | Wireless | Instream",
                        "attributionClickConversionRate": 0,
                        "dataECPM": 0.0016945792533224376,
                        "attributionViewConversionRate": 0
                    },
                    "data": []
                },
                {
                    "key": "publisherName",
                    "total": {
                        "demandECPM": 9.431421580483597,
                        "impressions": 496152,
                        "objectiveCountableSum": 496152,
                        "demandAttributionFee": 9.265499999999687,
                        "publisherId": 62,
                        "totalSpend": 954.3026999999992,
                        "attributionConversionReachUniqueUsers": 49,
                        "specialFormatFeeSum": 0,
                        "publisherName": "(62) Absolute Radio | Bauer | Instream",
                        "attributionClickConversionRate": 0,
                        "dataECPM": 0.06074710975668718,
                        "attributionViewConversionRate": 0
                    },
                    "data": []
                },
                {
                    "key": "publisherName",
                    "total": {
                        "demandECPM": 9.61838062925561,
                        "impressions": 432384,
                        "objectiveCountableSum": 432384,
                        "demandAttributionFee": 5.495699999999874,
                        "publisherId": 143,
                        "totalSpend": 557.9716000000058,
                        "attributionConversionReachUniqueUsers": 29,
                        "specialFormatFeeSum": 0,
                        "publisherName": "(143) Planet Rock | Bauer | Instream",
                        "attributionClickConversionRate": 0,
                        "dataECPM": 0.04551995448490032,
                        "attributionViewConversionRate": 0
                    },
                    "data": []
                },
                {
                    "key": "publisherName",
                    "total": {
                        "demandECPM": 6.693000590997,
                        "impressions": 394249,
                        "objectiveCountableSum": 394249,
                        "demandAttributionFee": 3.9932999999999237,
                        "publisherId": 198,
                        "totalSpend": 418.0970000000047,
                        "attributionConversionReachUniqueUsers": 45,
                        "specialFormatFeeSum": 0,
                        "publisherName": "(198) Magic (National) | Bauer | Instream",
                        "attributionClickConversionRate": 0,
                        "dataECPM": 0.041848679387898186,
                        "attributionViewConversionRate": 0
                    },
                    "data": []
                },
                {
                    "key": "publisherName",
                    "total": {
                        "demandECPM": 5.3147868654105554,
                        "impressions": 279354,
                        "objectiveCountableSum": 279354,
                        "demandAttributionFee": 0.5576999999999972,
                        "publisherId": 20,
                        "totalSpend": 39.6288000000002,
                        "attributionConversionReachUniqueUsers": 0,
                        "specialFormatFeeSum": 0.00317646,
                        "publisherName": "(20) Virgin Radio UK | Wireless | Instream",
                        "attributionClickConversionRate": 0,
                        "dataECPM": 0.002192558545787791,
                        "attributionViewConversionRate": 0
                    },
                    "data": []
                },
                {
                    "key": "publisherName",
                    "total": {
                        "demandECPM": 9.729745874855713,
                        "impressions": 270536,
                        "objectiveCountableSum": 270536,
                        "demandAttributionFee": 4.193699999999945,
                        "publisherId": 33,
                        "totalSpend": 430.0538000000022,
                        "attributionConversionReachUniqueUsers": 16,
                        "specialFormatFeeSum": 0,
                        "publisherName": "(33) Greatest Hits Radio (National) | Bauer | Instream",
                        "attributionClickConversionRate": 0,
                        "dataECPM": 0.056846593429338406,
                        "attributionViewConversionRate": 0
                    },
                    "data": []
                },
                {
                    "key": "publisherName",
                    "total": {
                        "demandECPM": 9.272700418785451,
                        "impressions": 254068,
                        "objectiveCountableSum": 254068,
                        "demandAttributionFee": 3.5350499999999703,
                        "publisherId": 65,
                        "totalSpend": 355.80734999999714,
                        "attributionConversionReachUniqueUsers": 22,
                        "specialFormatFeeSum": 0,
                        "publisherName": "(65) Absolute 80s | Bauer | Instream",
                        "attributionClickConversionRate": 0,
                        "dataECPM": 0.0571781963883669,
                        "attributionViewConversionRate": 0
                    },
                    "data": []
                },
                {
                    "key": "publisherName",
                    "total": {
                        "demandECPM": 7.43929200330009,
                        "impressions": 250891,
                        "objectiveCountableSum": 250891,
                        "demandAttributionFee": 3.1369500000000174,
                        "publisherId": 123,
                        "totalSpend": 317.1092499999977,
                        "attributionConversionReachUniqueUsers": 24,
                        "specialFormatFeeSum": 0,
                        "publisherName": "(123) Kisstory | Bauer | Instream",
                        "attributionClickConversionRate": 0,
                        "dataECPM": 0.034538704058734326,
                        "attributionViewConversionRate": 0
                    },
                    "data": []
                }
            ],
            "attributes": {
                "granularity": "DAY",
                "valueType": "TIME"
            }
        },
        {
            "key": "__time",
            "total": {
                "__time": {
                    "start": "2023-12-07T00:00:00+0000",
                    "end": "2023-12-08T00:00:00+0000"
                },
                "totalSpend": 7150.038300001286,
                "attributionConversionReachUniqueUsers": 433,
                "demandECPM": 7.278284006128912,
                "specialFormatFeeSum": 0.00158916,
                "attributionClickConversionRate": 0,
                "impressions": 9943474,
                "objectiveCountableSum": 9924546,
                "dataECPM": 0.032328209270225915,
                "attributionViewConversionRate": 0,
                "demandAttributionFee": 72.30239999998021
            },
            "data": [
                {
                    "key": "publisherName",
                    "total": {
                        "demandECPM": 5.13572797249298,
                        "impressions": 4241946,
                        "objectiveCountableSum": 4241946,
                        "demandAttributionFee": 6.901049999999864,
                        "publisherId": 9,
                        "totalSpend": 495.6017499999985,
                        "attributionConversionReachUniqueUsers": 2,
                        "specialFormatFeeSum": 0,
                        "publisherName": "(9) talkSPORT | Wireless | Instream",
                        "attributionClickConversionRate": 0,
                        "dataECPM": 0.001647133178970145,
                        "attributionViewConversionRate": 0
                    },
                    "data": []
                },
                {
                    "key": "publisherName",
                    "total": {
                        "demandECPM": 9.740494924286946,
                        "impressions": 532930,
                        "objectiveCountableSum": 532930,
                        "demandAttributionFee": 10.341749999999957,
                        "publisherId": 62,
                        "totalSpend": 1061.369449999993,
                        "attributionConversionReachUniqueUsers": 53,
                        "specialFormatFeeSum": 0,
                        "publisherName": "(62) Absolute Radio | Bauer | Instream",
                        "attributionClickConversionRate": 0,
                        "dataECPM": 0.07196282813878074,
                        "attributionViewConversionRate": 0
                    },
                    "data": []
                },
                {
                    "key": "publisherName",
                    "total": {
                        "demandECPM": 9.732244971229218,
                        "impressions": 409444,
                        "objectiveCountableSum": 409444,
                        "demandAttributionFee": 5.573849999999842,
                        "publisherId": 143,
                        "totalSpend": 564.5325500000073,
                        "attributionConversionReachUniqueUsers": 110,
                        "specialFormatFeeSum": 0,
                        "publisherName": "(143) Planet Rock | Bauer | Instream",
                        "attributionClickConversionRate": 0,
                        "dataECPM": 0.05835218002950233,
                        "attributionViewConversionRate": 0
                    },
                    "data": []
                },
                {
                    "key": "publisherName",
                    "total": {
                        "demandECPM": 7.313772539469382,
                        "impressions": 407341,
                        "objectiveCountableSum": 407341,
                        "demandAttributionFee": 4.6321499999999,
                        "publisherId": 198,
                        "totalSpend": 485.9201500000066,
                        "attributionConversionReachUniqueUsers": 107,
                        "specialFormatFeeSum": 0,
                        "publisherName": "(198) Magic (National) | Bauer | Instream",
                        "attributionClickConversionRate": 0,
                        "dataECPM": 0.05755276291853582,
                        "attributionViewConversionRate": 0
                    },
                    "data": []
                },
                {
                    "key": "publisherName",
                    "total": {
                        "demandECPM": 5.395274228214126,
                        "impressions": 298237,
                        "objectiveCountableSum": 298237,
                        "demandAttributionFee": 0.5408999999999974,
                        "publisherId": 20,
                        "totalSpend": 38.74840000000023,
                        "attributionConversionReachUniqueUsers": 0,
                        "specialFormatFeeSum": 0.00158916,
                        "publisherName": "(20) Virgin Radio UK | Wireless | Instream",
                        "attributionClickConversionRate": 0,
                        "dataECPM": 0.0020361323377045826,
                        "attributionViewConversionRate": 0
                    },
                    "data": []
                },
                {
                    "key": "publisherName",
                    "total": {
                        "demandECPM": 9.959616917426356,
                        "impressions": 288058,
                        "objectiveCountableSum": 288058,
                        "demandAttributionFee": 4.756649999999895,
                        "publisherId": 33,
                        "totalSpend": 488.07215000000605,
                        "attributionConversionReachUniqueUsers": 36,
                        "specialFormatFeeSum": 0,
                        "publisherName": "(33) Greatest Hits Radio (National) | Bauer | Instream",
                        "attributionClickConversionRate": 0,
                        "dataECPM": 0.07017614508189188,
                        "attributionViewConversionRate": 0
                    },
                    "data": []
                },
                {
                    "key": "publisherName",
                    "total": {
                        "demandECPM": 8.837461346048022,
                        "impressions": 255860,
                        "objectiveCountableSum": 255860,
                        "demandAttributionFee": 0.7477499999999976,
                        "publisherId": 347,
                        "totalSpend": 53.236950000000284,
                        "attributionConversionReachUniqueUsers": 0,
                        "specialFormatFeeSum": 0,
                        "publisherName": "(347) talkRADIO | Wireless | Instream",
                        "attributionClickConversionRate": 0,
                        "dataECPM": 0.003372156648166998,
                        "attributionViewConversionRate": 0
                    },
                    "data": []
                },
                {
                    "key": "publisherName",
                    "total": {
                        "demandECPM": 8.209047527858543,
                        "impressions": 245435,
                        "objectiveCountableSum": 245435,
                        "demandAttributionFee": 3.3146999999999918,
                        "publisherId": 123,
                        "totalSpend": 334.90839999999866,
                        "attributionConversionReachUniqueUsers": 46,
                        "specialFormatFeeSum": 0,
                        "publisherName": "(123) Kisstory | Bauer | Instream",
                        "attributionClickConversionRate": 0,
                        "dataECPM": 0.04743394381404303,
                        "attributionViewConversionRate": 0
                    },
                    "data": []
                }
            ],
            "attributes": {
                "granularity": "DAY",
                "valueType": "TIME"
            }
        },
        {
            "key": "__time",
            "total": {
                "__time": {
                    "start": "2023-12-06T00:00:00+0000",
                    "end": "2023-12-07T00:00:00+0000"
                },
                "totalSpend": 7230.279050000974,
                "attributionConversionReachUniqueUsers": 487,
                "demandECPM": 7.28780066742349,
                "specialFormatFeeSum": 0,
                "attributionClickConversionRate": 0,
                "impressions": 9983821,
                "objectiveCountableSum": 9964182,
                "dataECPM": 0.034278579014308586,
                "attributionViewConversionRate": 0,
                "demandAttributionFee": 73.11704999998406
            },
            "data": [
                {
                    "key": "publisherName",
                    "total": {
                        "demandECPM": 5.235275861940162,
                        "impressions": 4292582,
                        "objectiveCountableSum": 4292582,
                        "demandAttributionFee": 6.919799999999905,
                        "publisherId": 9,
                        "totalSpend": 497.7642000000057,
                        "attributionConversionReachUniqueUsers": 2,
                        "specialFormatFeeSum": 0,
                        "publisherName": "(9) talkSPORT | Wireless | Instream",
                        "attributionClickConversionRate": 0,
                        "dataECPM": 0.0016691585623756886,
                        "attributionViewConversionRate": 0
                    },
                    "data": []
                },
                {
                    "key": "publisherName",
                    "total": {
                        "demandECPM": 9.834627202370909,
                        "impressions": 537262,
                        "objectiveCountableSum": 537262,
                        "demandAttributionFee": 11.017499999999675,
                        "publisherId": 62,
                        "totalSpend": 1130.1943999999976,
                        "attributionConversionReachUniqueUsers": 98,
                        "specialFormatFeeSum": 0,
                        "publisherName": "(62) Absolute Radio | Bauer | Instream",
                        "attributionClickConversionRate": 0,
                        "dataECPM": 0.07745839087819527,
                        "attributionViewConversionRate": 0
                    },
                    "data": []
                },
                {
                    "key": "publisherName",
                    "total": {
                        "demandECPM": 10.07520620855731,
                        "impressions": 439458,
                        "objectiveCountableSum": 439458,
                        "demandAttributionFee": 6.014549999999832,
                        "publisherId": 143,
                        "totalSpend": 610.9390500000081,
                        "attributionConversionReachUniqueUsers": 59,
                        "specialFormatFeeSum": 0,
                        "publisherName": "(143) Planet Rock | Bauer | Instream",
                        "attributionClickConversionRate": 0,
                        "dataECPM": 0.06490586131097822,
                        "attributionViewConversionRate": 0
                    },
                    "data": []
                },
                {
                    "key": "publisherName",
                    "total": {
                        "demandECPM": 7.303427087444026,
                        "impressions": 392765,
                        "objectiveCountableSum": 392765,
                        "demandAttributionFee": 4.29914999999994,
                        "publisherId": 198,
                        "totalSpend": 453.25895000000264,
                        "attributionConversionReachUniqueUsers": 127,
                        "specialFormatFeeSum": 0,
                        "publisherName": "(198) Magic (National) | Bauer | Instream",
                        "attributionClickConversionRate": 0,
                        "dataECPM": 0.05700597049125836,
                        "attributionViewConversionRate": 0
                    },
                    "data": []
                },
                {
                    "key": "publisherName",
                    "total": {
                        "demandECPM": 5.524511346481563,
                        "impressions": 325916,
                        "objectiveCountableSum": 325916,
                        "demandAttributionFee": 0.5969999999999973,
                        "publisherId": 20,
                        "totalSpend": 43.02220000000027,
                        "attributionConversionReachUniqueUsers": 0,
                        "specialFormatFeeSum": 0,
                        "publisherName": "(20) Virgin Radio UK | Wireless | Instream",
                        "attributionClickConversionRate": 0,
                        "dataECPM": 0.0023869647393807156,
                        "attributionViewConversionRate": 0
                    },
                    "data": []
                },
                {
                    "key": "publisherName",
                    "total": {
                        "demandECPM": 10.104298714647575,
                        "impressions": 298673,
                        "objectiveCountableSum": 298673,
                        "demandAttributionFee": 4.732649999999906,
                        "publisherId": 33,
                        "totalSpend": 484.06325000000487,
                        "attributionConversionReachUniqueUsers": 62,
                        "specialFormatFeeSum": 0,
                        "publisherName": "(33) Greatest Hits Radio (National) | Bauer | Instream",
                        "attributionClickConversionRate": 0,
                        "dataECPM": 0.07367154044724297,
                        "attributionViewConversionRate": 0
                    },
                    "data": []
                },
                {
                    "key": "publisherName",
                    "total": {
                        "demandECPM": 8.933166437131186,
                        "impressions": 253411,
                        "objectiveCountableSum": 253411,
                        "demandAttributionFee": 0.7687499999999973,
                        "publisherId": 347,
                        "totalSpend": 54.498950000000306,
                        "attributionConversionReachUniqueUsers": 1,
                        "specialFormatFeeSum": 0,
                        "publisherName": "(347) talkRADIO | Wireless | Instream",
                        "attributionClickConversionRate": 0,
                        "dataECPM": 0.003455059172648415,
                        "attributionViewConversionRate": 0
                    },
                    "data": []
                },
                {
                    "key": "publisherName",
                    "total": {
                        "demandECPM": 8.120710519644941,
                        "impressions": 236700,
                        "objectiveCountableSum": 236700,
                        "demandAttributionFee": 3.199950000000026,
                        "publisherId": 123,
                        "totalSpend": 324.1987499999975,
                        "attributionConversionReachUniqueUsers": 50,
                        "specialFormatFeeSum": 0,
                        "publisherName": "(123) Kisstory | Bauer | Instream",
                        "attributionClickConversionRate": 0,
                        "dataECPM": 0.049039712716517594,
                        "attributionViewConversionRate": 0
                    },
                    "data": []
                }
            ],
            "attributes": {
                "granularity": "DAY",
                "valueType": "TIME"
            }
        },
        {
            "key": "__time",
            "total": {
                "__time": {
                    "start": "2023-12-05T00:00:00+0000",
                    "end": "2023-12-06T00:00:00+0000"
                },
                "totalSpend": 7212.57565000092,
                "attributionConversionReachUniqueUsers": 574,
                "demandECPM": 7.253103672725692,
                "specialFormatFeeSum": 0,
                "attributionClickConversionRate": 0,
                "impressions": 9543605,
                "objectiveCountableSum": 9522051,
                "dataECPM": 0.03729659713017294,
                "attributionViewConversionRate": 0,
                "demandAttributionFee": 72.98744999998708
            },
            "data": [
                {
                    "key": "publisherName",
                    "total": {
                        "demandECPM": 5.306365925472295,
                        "impressions": 4055569,
                        "objectiveCountableSum": 4055569,
                        "demandAttributionFee": 6.549149999999875,
                        "publisherId": 9,
                        "totalSpend": 468.6346500000034,
                        "attributionConversionReachUniqueUsers": 3,
                        "specialFormatFeeSum": 0,
                        "publisherName": "(9) talkSPORT | Wireless | Instream",
                        "attributionClickConversionRate": 0,
                        "dataECPM": 0.0027837770729580626,
                        "attributionViewConversionRate": 0
                    },
                    "data": []
                },
                {
                    "key": "publisherName",
                    "total": {
                        "demandECPM": 9.647334068944822,
                        "impressions": 495733,
                        "objectiveCountableSum": 495733,
                        "demandAttributionFee": 10.157549999999755,
                        "publisherId": 62,
                        "totalSpend": 1046.1606500000014,
                        "attributionConversionReachUniqueUsers": 115,
                        "specialFormatFeeSum": 0,
                        "publisherName": "(62) Absolute Radio | Bauer | Instream",
                        "attributionClickConversionRate": 0,
                        "dataECPM": 0.08062323871922972,
                        "attributionViewConversionRate": 0
                    },
                    "data": []
                },
                {
                    "key": "publisherName",
                    "total": {
                        "demandECPM": 9.90649718233877,
                        "impressions": 431741,
                        "objectiveCountableSum": 431741,
                        "demandAttributionFee": 6.285299999999811,
                        "publisherId": 143,
                        "totalSpend": 635.0989000000119,
                        "attributionConversionReachUniqueUsers": 84,
                        "specialFormatFeeSum": 0,
                        "publisherName": "(143) Planet Rock | Bauer | Instream",
                        "attributionClickConversionRate": 0,
                        "dataECPM": 0.07051276112298784,
                        "attributionViewConversionRate": 0
                    },
                    "data": []
                },
                {
                    "key": "publisherName",
                    "total": {
                        "demandECPM": 7.0380393751426755,
                        "impressions": 376278,
                        "objectiveCountableSum": 376278,
                        "demandAttributionFee": 4.1608499999999395,
                        "publisherId": 198,
                        "totalSpend": 432.92495000000434,
                        "attributionConversionReachUniqueUsers": 132,
                        "specialFormatFeeSum": 0,
                        "publisherName": "(198) Magic (National) | Bauer | Instream",
                        "attributionClickConversionRate": 0,
                        "dataECPM": 0.060555360664187256,
                        "attributionViewConversionRate": 0
                    },
                    "data": []
                },
                {
                    "key": "publisherName",
                    "total": {
                        "demandECPM": 5.181254178339959,
                        "impressions": 310530,
                        "objectiveCountableSum": 310530,
                        "demandAttributionFee": 0.5791499999999972,
                        "publisherId": 20,
                        "totalSpend": 41.334950000000276,
                        "attributionConversionReachUniqueUsers": 0,
                        "specialFormatFeeSum": 0,
                        "publisherName": "(20) Virgin Radio UK | Wireless | Instream",
                        "attributionClickConversionRate": 0,
                        "dataECPM": 0.003384536115673232,
                        "attributionViewConversionRate": 0
                    },
                    "data": []
                },
                {
                    "key": "publisherName",
                    "total": {
                        "demandECPM": 10.082609055614382,
                        "impressions": 283846,
                        "objectiveCountableSum": 283846,
                        "demandAttributionFee": 4.813799999999903,
                        "publisherId": 33,
                        "totalSpend": 491.07060000000416,
                        "attributionConversionReachUniqueUsers": 66,
                        "specialFormatFeeSum": 0,
                        "publisherName": "(33) Greatest Hits Radio (National) | Bauer | Instream",
                        "attributionClickConversionRate": 0,
                        "dataECPM": 0.07637609830682592,
                        "attributionViewConversionRate": 0
                    },
                    "data": []
                },
                {
                    "key": "publisherName",
                    "total": {
                        "demandECPM": 8.86208039259697,
                        "impressions": 266940,
                        "objectiveCountableSum": 266940,
                        "demandAttributionFee": 0.9202499999999953,
                        "publisherId": 347,
                        "totalSpend": 64.88955000000045,
                        "attributionConversionReachUniqueUsers": 0,
                        "specialFormatFeeSum": 0,
                        "publisherName": "(347) talkRADIO | Wireless | Instream",
                        "attributionClickConversionRate": 0,
                        "dataECPM": 0.006056042556379739,
                        "attributionViewConversionRate": 0
                    },
                    "data": []
                },
                {
                    "key": "publisherName",
                    "total": {
                        "demandECPM": 9.450233752183815,
                        "impressions": 232939,
                        "objectiveCountableSum": 232939,
                        "demandAttributionFee": 3.5676000000000028,
                        "publisherId": 65,
                        "totalSpend": 360.22639999999626,
                        "attributionConversionReachUniqueUsers": 46,
                        "specialFormatFeeSum": 0,
                        "publisherName": "(65) Absolute 80s | Bauer | Instream",
                        "attributionClickConversionRate": 0,
                        "dataECPM": 0.0813833235310498,
                        "attributionViewConversionRate": 0
                    },
                    "data": []
                }
            ],
            "attributes": {
                "granularity": "DAY",
                "valueType": "TIME"
            }
        },
        {
            "key": "__time",
            "total": {
                "__time": {
                    "start": "2023-12-04T00:00:00+0000",
                    "end": "2023-12-05T00:00:00+0000"
                },
                "totalSpend": 7419.397100001097,
                "attributionConversionReachUniqueUsers": 633,
                "demandECPM": 6.839794018343957,
                "specialFormatFeeSum": 0,
                "attributionClickConversionRate": 0,
                "impressions": 9460448,
                "objectiveCountableSum": 9440792,
                "dataECPM": 0.03977403590715377,
                "attributionViewConversionRate": 0,
                "demandAttributionFee": 75.23909999999056
            },
            "data": [
                {
                    "key": "publisherName",
                    "total": {
                        "demandECPM": 4.751581706038908,
                        "impressions": 4158181,
                        "objectiveCountableSum": 4158181,
                        "demandAttributionFee": 7.340999999999764,
                        "publisherId": 9,
                        "totalSpend": 532.0187999999922,
                        "attributionConversionReachUniqueUsers": 4,
                        "specialFormatFeeSum": 0,
                        "publisherName": "(9) talkSPORT | Wireless | Instream",
                        "attributionClickConversionRate": 0,
                        "dataECPM": 0.004282521612214553,
                        "attributionViewConversionRate": 0
                    },
                    "data": []
                },
                {
                    "key": "publisherName",
                    "total": {
                        "demandECPM": 9.583123716955278,
                        "impressions": 477380,
                        "objectiveCountableSum": 477380,
                        "demandAttributionFee": 10.71809999999972,
                        "publisherId": 62,
                        "totalSpend": 1108.5028000000018,
                        "attributionConversionReachUniqueUsers": 167,
                        "specialFormatFeeSum": 0,
                        "publisherName": "(62) Absolute Radio | Bauer | Instream",
                        "attributionClickConversionRate": 0,
                        "dataECPM": 0.09108917424274285,
                        "attributionViewConversionRate": 0
                    },
                    "data": []
                },
                {
                    "key": "publisherName",
                    "total": {
                        "demandECPM": 9.84822779350391,
                        "impressions": 424279,
                        "objectiveCountableSum": 424279,
                        "demandAttributionFee": 6.673949999999789,
                        "publisherId": 143,
                        "totalSpend": 670.8037500000107,
                        "attributionConversionReachUniqueUsers": 86,
                        "specialFormatFeeSum": 0,
                        "publisherName": "(143) Planet Rock | Bauer | Instream",
                        "attributionClickConversionRate": 0,
                        "dataECPM": 0.07364422938679449,
                        "attributionViewConversionRate": 0
                    },
                    "data": []
                },
                {
                    "key": "publisherName",
                    "total": {
                        "demandECPM": 6.734993261989578,
                        "impressions": 365835,
                        "objectiveCountableSum": 365835,
                        "demandAttributionFee": 4.217549999999965,
                        "publisherId": 198,
                        "totalSpend": 440.4930500000016,
                        "attributionConversionReachUniqueUsers": 119,
                        "specialFormatFeeSum": 0,
                        "publisherName": "(198) Magic (National) | Bauer | Instream",
                        "attributionClickConversionRate": 0,
                        "dataECPM": 0.06518348435769922,
                        "attributionViewConversionRate": 0
                    },
                    "data": []
                },
                {
                    "key": "publisherName",
                    "total": {
                        "demandECPM": 4.717696737773687,
                        "impressions": 289281,
                        "objectiveCountableSum": 289281,
                        "demandAttributionFee": 0.5644499999999975,
                        "publisherId": 20,
                        "totalSpend": 40.80515000000021,
                        "attributionConversionReachUniqueUsers": 1,
                        "specialFormatFeeSum": 0,
                        "publisherName": "(20) Virgin Radio UK | Wireless | Instream",
                        "attributionClickConversionRate": 0,
                        "dataECPM": 0.005857799164134479,
                        "attributionViewConversionRate": 0
                    },
                    "data": []
                },
                {
                    "key": "publisherName",
                    "total": {
                        "demandECPM": 9.982875825399187,
                        "impressions": 272141,
                        "objectiveCountableSum": 272141,
                        "demandAttributionFee": 5.0074499999998885,
                        "publisherId": 33,
                        "totalSpend": 507.8045500000052,
                        "attributionConversionReachUniqueUsers": 79,
                        "specialFormatFeeSum": 0,
                        "publisherName": "(33) Greatest Hits Radio (National) | Bauer | Instream",
                        "attributionClickConversionRate": 0,
                        "dataECPM": 0.08185830139523094,
                        "attributionViewConversionRate": 0
                    },
                    "data": []
                },
                {
                    "key": "publisherName",
                    "total": {
                        "demandECPM": 7.952517463637985,
                        "impressions": 237064,
                        "objectiveCountableSum": 237064,
                        "demandAttributionFee": 0.926549999999995,
                        "publisherId": 347,
                        "totalSpend": 65.93965000000047,
                        "attributionConversionReachUniqueUsers": 0,
                        "specialFormatFeeSum": 0,
                        "publisherName": "(347) talkRADIO | Wireless | Instream",
                        "attributionClickConversionRate": 0,
                        "dataECPM": 0.011338077481186365,
                        "attributionViewConversionRate": 0
                    },
                    "data": []
                },
                {
                    "key": "publisherName",
                    "total": {
                        "demandECPM": 9.277147708909554,
                        "impressions": 219066,
                        "objectiveCountableSum": 219066,
                        "demandAttributionFee": 3.449849999999999,
                        "publisherId": 65,
                        "totalSpend": 348.73874999999873,
                        "attributionConversionReachUniqueUsers": 39,
                        "specialFormatFeeSum": 0,
                        "publisherName": "(65) Absolute 80s | Bauer | Instream",
                        "attributionClickConversionRate": 0,
                        "dataECPM": 0.08488902887713963,
                        "attributionViewConversionRate": 0
                    },
                    "data": []
                }
            ],
            "attributes": {
                "granularity": "DAY",
                "valueType": "TIME"
            }
        }
    ],
    "attributes": null,
    "errorMessage": null
}
